import React from 'react';
import { IScopeContext } from '../types';

export const ScopeContext = React.createContext<IScopeContext>({
  defaults: {},
  allowedKeys: [],
});
